// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__29R_g"};